export const PROHIBITED_WORDS = {
  TITLE_TEXT: 'Prohibited Words',
  SUBTITLE_TEXT: 'Last updated: 7 June 2024',
};
